setInterval(() => {
  if ($("cart-drawer-items").hasClass("is-empty")) {
      //console.log("The element is empty!");
      $("cart-drawer").addClass('is-empty');
  } else {
      $("cart-drawer").removeClass('is-empty');
      //console.log("The element is not empty.");
  }
}, 2);


// $('.thumbnail-slider').on('mouseenter', function () {
//   $(".product .grid__item.product__media-wrapper .p-tag").stop(true, true).fadeOut(200);
// });

// $('.thumbnail-slider').on('mouseleave', function () {
//   $(".product .grid__item.product__media-wrapper .p-tag").stop(true, true).fadeIn(200);
// });



document.addEventListener('DOMContentLoaded', function () {

  const initializedWidgets = new WeakSet();

  function initRechargeWidget(widget) {

    // Prevent duplicate listeners
    if (initializedWidgets.has(widget)) {
      return;
    }

    // Recharge Shadow DOM may not be ready yet
    if (!widget.shadowRoot) {
      setTimeout(function () {
        initRechargeWidget(widget);
      }, 300);

      return;
    }

    initializedWidgets.add(widget);

    const shadow = widget.shadowRoot;

    let lastSelected = null;


    function checkSelectedOption() {

      // Give Recharge time to update checked state
      setTimeout(function () {

        const subscriptionOption = shadow.querySelector(
          '[part~="rc-purchase-option__subscription"]'
        );

        const oneTimeOption = shadow.querySelector(
          '[part~="rc-purchase-option__onetime"]'
        );


        /*
         * Check subscription
         */
        const subscriptionRadio = subscriptionOption
          ? subscriptionOption.querySelector('input[type="radio"]')
          : null;


        /*
         * Check one-time
         */
        const oneTimeRadio = oneTimeOption
          ? oneTimeOption.querySelector('input[type="radio"]')
          : null;


        /*
         * Subscription selected
         */
        if (
          (subscriptionRadio && subscriptionRadio.checked) ||
          (subscriptionOption &&
            subscriptionOption.getAttribute('part')?.includes(
              'rc-purchase-option__selected'
            ))
        ) {

          if (lastSelected !== 'subscription') {

            lastSelected = 'subscription';

            console.log('✅ SUBSCRIPTION SELECTED');


            /*
             * FIRE YOUR EVENT
             */
            document.dispatchEvent(
              new CustomEvent('recharge:subscription-selected', {
                detail: {
                  type: 'subscription'
                }
              })
            );

          }

          return;
        }


        /*
         * One-time selected
         */
        if (
          (oneTimeRadio && oneTimeRadio.checked) ||
          (oneTimeOption &&
            oneTimeOption.getAttribute('part')?.includes(
              'rc-purchase-option__selected'
            ))
        ) {

          if (lastSelected !== 'onetime') {

            lastSelected = 'onetime';

            console.log('✅ ONE TIME PURCHASE SELECTED');

            


            /*
             * FIRE YOUR EVENT
             */
            document.dispatchEvent(
              new CustomEvent('recharge:onetime-selected', {
                detail: {
                  type: 'onetime'
                }
              })
            );

          }

        }

      }, 100);

    }


    /*
     * Listen for radio changes
     */
    shadow.addEventListener(
      'change',
      function () {
        checkSelectedOption();
      },
      true
    );


    /*
     * Also listen for click
     * Recharge sometimes updates selection after click
     */
    shadow.addEventListener(
      'click',
      function () {
        checkSelectedOption();
      },
      true
    );


    /*
     * Watch Recharge DOM changes
     */
    const observer = new MutationObserver(function () {
      checkSelectedOption();
    });

    observer.observe(shadow, {
      subtree: true,
      attributes: true,
      attributeFilter: [
        'part',
        'checked',
        'aria-checked'
      ]
    });


    /*
     * Detect currently selected option
     */
    checkSelectedOption();

  }


  /*
   * Find Recharge widgets
   */
  function findRechargeWidgets() {

    document
      .querySelectorAll('recharge-subscription-widget')
      .forEach(function (widget) {

        initRechargeWidget(widget);

      });

  }


  /*
   * Initial check
   */
  findRechargeWidgets();


  /*
   * Recharge may load widget later
   */
  const pageObserver = new MutationObserver(function () {

    findRechargeWidgets();

  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener(
  'recharge:onetime-selected',
  function (event) {

    console.log('One Time Purchase event fired !!!!!!');

    $(".custombadge_badge_sale.selling_planactive").hide();
    $("span.custombadge_badge_sale.selling_planactive + span.custombadge_badge_sale").show().addClass('active');

    // YOUR CODE HERE

  }
);

document.addEventListener(
  'recharge:subscription-selected',
  function () {

    $(".custombadge_badge_sale.selling_planactive").show();
    $("span.custombadge_badge_sale.selling_planactive + span.custombadge_badge_sale").hide().removeClass('active');

  }
);


$("variant-selects .Quantity label").on('click',function(){
    var thisVal = $(this).find(".option-name").html();
    var thisDatacount =$(this).attr('data-vcount');
    $(this).parent().parent().find(".number-of-items").html(thisVal);
    $(".gift-items-wrap .number-of-items").html(thisVal);
});

$("variant-selects .Flavour label").on('click',function(){
    var thisVal = $(this).find(".option-name").html();
    console.log(thisVal);
    var thisDatacount =$(this).attr('data-vcount');
    $(this).parent().parent().find(".number-of-items").html(thisVal);
});


 $('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
  infinite: false,
  centerMode: false,
  centerPadding: '40px',
  touchMove:false,
  asNavFor: '.thumbnail-list',
  prevArrow:"<span class='a-left control-c prev slick-prev'><img src='https://drinksoulbrew.com/cdn/shop/files/left-arrow.svg?v=1778738258' /></span>",
  nextArrow:"<span class='a-right control-c next slick-next'><img src='https://drinksoulbrew.com/cdn/shop/files/right-arrow.svg?v=1778738258' /></span>",
  responsive: [
        {
          breakpoint: 580,
          settings: {
            centerMode: false,
          }
        },
      ]
});

$('.product__media-list').on('afterChange', function(event, slick, currentSlide) {

  const $tag = $(".product .grid__item.product__media-wrapper .p-tag");

  if (currentSlide === 0) {
    $tag.stop(true, true).fadeIn(200);
  } else {
    $tag.stop(true, true).fadeOut(200);
  }

});


(function () {
  console.log('show-before script running');

  function update() {
    var gallery = document.querySelector('.cl-po--gallery-main');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    var idx = -1;
    slides.forEach(function (s, i) {
      if (s.classList.contains('is-active')) idx = i;
    });

    gallery.classList.toggle('show-before', idx === 0);
  }

  setInterval(update, 200);
})();





$('.thumbnail-list').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product__media-list',
  infinite: false,
  dots: false,
  arrows: false,
  touchMove:false,
  centerMode: false,
  focusOnSelect: true,
  draggable:true,
  responsive: [
        {
          breakpoint: 580,
          settings: {
            draggable:false,
            touchMove:true,
          }
        },
      ]
});







$('.video_review').slick({
  slidesToShow: 6.2,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: true,
  speed: 500,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4.2
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 3.2
      }
    },
    {
      breakpoint: 810,
      settings: {
        slidesToShow: 2.2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.1,
        dots:false,
        arrows:true
      }
    }
  ]
});


$(".ingredients-all-data").click(function (e) {
  $(this)
    .toggleClass("active")
    .next(".paragraph-text")
    .slideToggle()
    .closest(".ingredients-all-data_wrapper")
    .siblings(".ingredients-all-data_wrapper")
    .find(".ingredients-all-data")
    .removeClass("active")
    .next(".paragraph-text")
    .slideUp();
});


//Sidebar

$(document).ready(function () {

    // add close button dynamically
    $('.content-sidebar').prepend(
        '<button class="sidebar-close">×</button>'
    );

    // open sidebar
    $('.fuel_your_body .content a').on('click', function (e) {

        e.preventDefault();

        $('.content-sidebar').removeClass('active');

        $(this)
            .closest('.item')
            .find('.content-sidebar')
            .addClass('active');

    });

    // close sidebar
    $(document).on('click', '.sidebar-close', function () {

        $(this)
            .closest('.content-sidebar')
            .removeClass('active');

    });

});

$(document).on('click', function(e){

    // if sidebar is active
    if ($('.content-sidebar.active').length) {

        // clicked outside sidebar AND outside info button
        if (
            !$(e.target).closest('.content-sidebar').length &&
            !$(e.target).closest('.fuel_your_body .content a').length
        ) {

            $('.content-sidebar').removeClass('active');

        }
    }

});


//Number Counter

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.fuel_your_body_grid .counter').forEach(counter => {

  let text = counter.innerText.trim();

  // extract number and suffix
  let number = parseFloat(text.replace(/[^0-9.]/g, ''));
  let suffix = text.replace(/[0-9.\s]/g, '');

  let obj = { val: 0 };

  gsap.to(obj, {
    val: number,
    duration: 2,
    ease: "power2.out",

    scrollTrigger: {
      trigger: counter,
      start: "top 85%",
      toggleActions: "play none none none",
    },

    onUpdate: () => {
      counter.innerText = Math.floor(obj.val) + " " + suffix;
    }
  });

});


//Recharge App Styling
function rechargeCustomLayout() {

  const rechargeWidget = document.querySelector('recharge-subscription-widget');

  if (!rechargeWidget || !rechargeWidget.shadowRoot) return;

  const shadow = rechargeWidget.shadowRoot;

  const option = shadow.querySelector('.rc-purchase-option__subscription');

  const badge = shadow.querySelector('#rc-subscription-badge');

  const selector = shadow.querySelector('.rc-purchase-option__selector');


  if (!option || !badge || !selector) return;

}


window.addEventListener('load', () => {
    setTimeout(rechargeCustomLayout, 100);
});





  


//Footer Menu

function footerAccordion() {

  const isMobile = window.innerWidth <= 580;

  const headings = document.querySelectorAll('.footer-block__heading');

  headings.forEach((heading) => {

    const menu = heading.nextElementSibling;

    if (!menu) return;

    // remove previous click event
    heading.onclick = null;

    // DESKTOP RESET
    if (!isMobile) {

      menu.style.display = '';

      const arrow = heading.querySelector('.footer-arrow');
      if (arrow) arrow.remove();

      heading.style.cursor = '';

      return;
    }

    // MOBILE SETUP

    // hide initially
    // menu.style.display = 'none';

    // Open first accordion by default
    if (heading === headings[0]) {
      menu.style.display = 'block';
    } else {
      menu.style.display = 'none';
    }

    // add arrow once
if (!heading.querySelector('.footer-arrow')) {
  heading.insertAdjacentHTML(
    'afterbegin',
    `<span class="footer-arrow" style="margin-right:8px;
      width:14px;
      height:14px;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      vertical-align:middle;
      transition:transform 0.3s ease;
      transform-origin:center;
      margin-bottom:10px;
      ${heading === headings[0] ? 'transform:rotate(180deg);' : ''}">
      <img src="https://cdn.shopify.com/s/files/1/0835/9995/0165/files/footer-menu-drop-up-arrow.svg?v=1779711721" width="12" height="12">
    </span>`
  );
}

    heading.style.cursor = 'pointer';

    heading.onclick = function () {

      const arrow = heading.querySelector('.footer-arrow');
      const isOpen = menu.style.display === 'block';

      // close all
      document.querySelectorAll('.footer-block__details-content').forEach(item => {
        item.style.display = 'none';
      });

      // reset arrows
      document.querySelectorAll('.footer-arrow').forEach(a => {
        a.style.transform = 'rotate(0deg)';
      });

      // open current
      if (!isOpen) {
        menu.style.display = 'block';
        arrow.style.transform = 'rotate(180deg)';
      }

    };

  });

}

$(document).ready(function() {
  footerAccordion();
});
$(window).resize(function() {
  console.log('hi');
  footerAccordion();
});
$(window).load(function() {
  footerAccordion();
});

